<template>
    <div class="home_page font-inter bg-neutral-100 text-neutral-800 min-h-screen flex flex-col">
        <header id="navbar" class="fixed w-full z-50 transition-all duration-300" :class="navClasses">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between items-center py-4">
                    <a href="#" class="flex items-center space-x-2">
                        <span class="text-2xl text-white font-bold tracking-tight text-shadow-lg">
                            <i class="fa fa-book-open mr-2"></i>
                            <WordOut text="LiAng(底部群聊可加~欢迎加入！)" fontSize="1.2rem" />
                            
                        </span>
                    </a>
                    <!-- 桌面导航 -->
                    <nav class="hidden md:flex space-x-8">
                        <a href="#home" @click="smoothScroll('#home')"
                            class="text-white hover:text-secondary transition-colors duration-200 font-medium">首页</a>
                        <a href="#novels" @click="smoothScroll('#novels')"
                            class="text-white hover:text-secondary transition-colors duration-200 font-medium">小说</a>
                        <a href="#poems" @click="smoothScroll('#poems')"
                            class="text-white hover:text-secondary transition-colors duration-200 font-medium">诗歌</a>
                        <a href="#about" @click="smoothScroll('#about')"
                            class="text-white hover:text-secondary transition-colors duration-200 font-medium">关于我</a>
                        <a href="#writer" @click.prevent="showLoginModal"
                            class="text-white hover:text-secondary transition-colors duration-200 font-medium">作家中心</a>
                    </nav>

                    <!-- 移动端菜单按钮 -->
                    <button id="menu-toggle" @click="toggleMobileMenu()"
                        class="md:hidden text-white focus:outline-none">
                        <i class="fa fa-bars text-2xl"></i>
                    </button>
                </div>
            </div>
            <!-- 移动端导航菜单 -->
            <div id="mobile-menu"
                :class="{ 'block': mobileMenuOpen, 'hidden': !mobileMenuOpen, 'md:hidden': true, 'bg-primary/95': true, 'backdrop-blur-sm': true, 'shadow-lg': true, 'p-4': true, 'space-y-4': true }">
                <div class="container mx-auto px-4 py-4 space-y-4">
                    <a href="#home" @click="() => { smoothScroll('#home'); toggleMobileMenu(); }"
                        class="block text-white hover:text-secondary transition-colors duration-200 font-medium py-2">首页</a>
                    <a href="#novels" @click="() => { smoothScroll('#novels'); toggleMobileMenu(); }"
                        class="block text-white hover:text-secondary transition-colors duration-200 font-medium py-2">小说</a>
                    <a href="#poems" @click="() => { smoothScroll('#poems'); toggleMobileMenu(); }"
                        class="block text-white hover:text-secondary transition-colors duration-200 font-medium py-2">诗歌</a>
                    <a href="#about" @click="() => { smoothScroll('#about'); toggleMobileMenu(); }"
                        class="block text-white hover:text-secondary transition-colors duration-200 font-medium py-2">关于我</a>
                </div>
            </div>
        </header>
        <!-- 轮播图区 -->
        <section id="home"
            class="relative h-screen flex items-center justify-center overflow-hidden bg-neutral-900/80 backdrop-blur-sm">
            <GirlKard :fullScreen="false" />
        </section>
        <!-- 互动插图（固定于屏幕右侧中偏上，随视口宽度缩放，层级最高） -->
        <div class="interact-picture">
            <!-- 左侧三个纵向选项框（可切换为继续阅读列表） -->
            <div class="action-options" :class="{ 'action-hidden': actionHidden }">
                <transition name="opt-fade" mode="out-in">
                    <!-- 默认三选项 -->
                    <div v-if="!showContinueList" key="menu-list" class="action-menu">
                        <button class="action-option" @click="showContinueList = true">1、继续阅读</button>
                        <button class="action-option" @click="handlePatHead">2、摸头</button>
                        <button class="action-option" @click="handleHit">3、打！</button>
                    </div>
                    <!-- 继续阅读列表（书名 + 第X章，可跳转） -->
                    <div v-else key="continue-list" class="action-menu">
                        <button v-for="item in continueList" :key="item.novelId"
                                class="action-option continue-option"
                                @click="goToReaderByHistory(item)">
                            {{ item.novelTitle }} {{ item.chapterTitle }}
                        </button>
                        <button v-if="continueList.length === 0" class="action-option continue-option">暂无阅读记录</button>
                    </div>
                </transition>
            </div>
            <!-- 图片 wrapper：整组右移出屏 -->
            <div class="interact-img-wrap" :class="{ 'interact-leaving': interactLeaving }">
                <!-- 图片：key 变化时触发快速淡出+淡入切换 -->
                <transition name="img-fade">
                    <img :key="currentInteractImg" :src="currentInteractImg" alt="互动插图">
                </transition>
            </div>
        </div>
        <!-- 小说作品 -->
        <section id="novels" class="py-20">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-12">
                    <div >
                        <h2 class="text-[clamp(1.75rem,3vw,2.5rem)] font-bold text-white mb-4">小说作品</h2>
                        <!-- <p class="text-neutral-600 max-w-2xl">
                            探索我的小说世界，这里有奇幻的冒险、深刻的思考和动人的故事</p> -->
                    </div>

                    <div class="mt-6 md:mt-0 flex space-x-2 overflow-x-auto pb-2 scrollbar-hide">
                        <button
                            class="px-4 py-2 bg-primary text-white rounded-full text-sm font-medium whitespace-nowrap">
                            全部
                        </button>
                        <button
                            class="px-4 py-2 bg-white text-neutral-700 hover:bg-neutral-100 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200">
                            科幻
                        </button>
                        <button
                            class="px-4 py-2 bg-white text-neutral-700 hover:bg-neutral-100 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200">
                            悬疑
                        </button>
                        <button
                            class="px-4 py-2 bg-white text-neutral-700 hover:bg-neutral-100 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200">
                            爱情
                        </button>
                        <button
                            class="px-4 py-2 bg-white text-neutral-700 hover:bg-neutral-100 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200">
                            奇幻
                        </button>
                    </div>
                </div>
                <!--md:768px屏幕监控-->
                <div class="hidden md:block">
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
                        <div v-for="novel in novels" :key="novel.id"
                            class="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 group cursor-pointer"
                            @click="goToNovelList(novel.id)">
                            <!-- 小说作品1 -->
                            <div
                                class="group bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300">
                                <div class="relative h-64 overflow-hidden">
                                    <img :src="novel.coverImage" alt="小说封面"
                                        class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105">

                                </div>
                                <div class="p-5">
                                    <h3
                                        class="text-lg font-bold text-neutral-800 mb-2 group-hover:text-primary transition-colors duration-200">
                                        {{ novel.title }}
                                    </h3>
                                    <p class="text-sm text-neutral-500 mb-3 line-clamp-2">
                                        {{ novel.description }}
                                    </p>
                                    <div class="flex justify-between items-center">
                                        <span class="text-xs text-neutral-500"><i class="fa fa-book mr-1"></i> {{
                                            novel.type }}</span>
                                        <button class="text-primary hover:text-primary/80">
                                            <i class="fa fa-bookmark-o text-lg"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 移动端展示 (默认隐藏) -->
                <div class="block md:hidden">
                    <div class="space-y-4">
                        <div v-for="novel in novels" :key="'mobile-' + novel.id"
                            class="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-4 flex gap-4"
                            @click="goToNovelList(novel.id)">
                            <!-- 移动端卡片内容 -->
                            <div class="flex-shrink-0 w-24 h-28 overflow-hidden rounded-md">
                                <img :src="novel.coverImage" alt="小说封面" class="w-full h-full object-cover">
                            </div>
                            <div class="flex-1 min-w-0">
                                <h3 class="text-base font-semibold text-gray-900 dark:text-white truncate">
                                    {{ novel.title }}
                                </h3>
                                <p class="text-sm text-gray-500 dark:text-gray-400 line-clamp-2 mt-1">
                                    {{ novel.description }}
                                </p>
                                <div class="flex items-center mt-2 text-xs text-gray-400">
                                    <span class="flex items-center mr-3">
                                        <i class="fa fa-book mr-1"></i>
                                        {{ novel.type }}
                                    </span><span class="flex items-center">
                                        <i class="fa fa-eye mr-1"></i>

                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 漫画作品 -->
        <section id="poems" class="py-20">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-12">
                    <div>
                        <h2 class="text-[clamp(1.75rem,3vw,2.5rem)] font-bold text-white mb-4">漫画作品</h2>

                    </div>
                    <div class="mt-6 md:mt-0 flex space-x-2 overflow-x-auto pb-2 scrollbar-hide">
                        <button
                            class="px-4 py-2 bg-accent text-white rounded-full text-sm font-medium whitespace-nowrap">全部
                        </button>
                        <button
                            class="px-4 py-2 bg-white text-neutral-700 hover:bg-neutral-100 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200">
                            爱情
                        </button>
                        <button
                            class="px-4 py-2 bg-white text-neutral-700 hover:bg-neutral-100 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200">
                            自然
                        </button>
                        <button
                            class="px-4 py-2 bg-white text-neutral-700 hover:bg-neutral-100 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200">
                            生活
                        </button>
                        <button
                            class="px-4 py-2 bg-white text-neutral-700 hover:bg-neutral-100 rounded-full text-sm font-medium whitespace-nowrap transition-colors duration-200">
                            哲理
                        </button>
                    </div>

                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <p class="text-neutral-300 max-w-2xl">暂无</p>
                </div>
            </div>
        </section>
        <!-- 关于我 -->
        <section id="about" class="py-20 bg-neutral-900 text-white">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    <div class="order-2 lg:order-1">
                        <h2 class="text-[clamp(1.75rem,3vw,2.5rem)] font-bold mb-6">关于我</h2>
                        <p class="text-neutral-300 mb-6 leading-relaxed">
                            听起来可能有些奇怪，我是一个计算机的技术人员，平时的爱好却是写作与阅读，偶尔也会画画(虽然技术得不怎么好…)。
                        </p>
                        <p class="text-neutral-300 mb-8 leading-relaxed">
                            我喜欢这些东西，它们里面有着用理性无法描述出的东西，是作者们内心的呈现。
                        </p>
                        <p class="text-neutral-300 mb-8 leading-relaxed">
                            写作是一种表达，也是一种探索和思考的过程。每一个故事，每一首诗歌，每一幅画作…都是内心世界的一部分。
                        </p>
                        
                    </div>

                    <div class="order-1 lg:order-2">
                        <div class="relative">
                            <div
                                class="absolute -inset-4 bg-gradient-to-r from-primary to-accent rounded-full blur-lg opacity-30 animate-pulse-slow">
                            </div>
                            <img src="@/assets/Picture/head2.jpg" alt="作者照片"
                                class="w-full h-auto rounded-xl shadow-2xl relative z-10">
                            <div
                                class="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6 rounded-b-xl z-20">
                                <div class="flex justify-between items-center">
                                    <div>
                                        <h3 class="text-xl font-bold">梦不沉沙</h3>
                                        <p class="text-neutral-300 text-sm">默默无闻的作家 | 兴趣使然的诗人</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-8 grid grid-cols-3 gap-4">
                            <div class="bg-white/5 backdrop-blur-sm p-4 rounded-lg text-center">
                                <h4 class="text-2xl font-bold text-secondary mb-1">4</h4>
                                <p class="text-neutral-400 text-sm">小说作品</p>
                            </div>
                            <div class="bg-white/5 backdrop-blur-sm p-4 rounded-lg text-center">
                                <h4 class="text-2xl font-bold text-secondary mb-1">0</h4>
                                <p class="text-neutral-400 text-sm">诗歌作品</p>
                            </div>
                            <div class="bg-white/5 backdrop-blur-sm p-4 rounded-lg text-center">
                                <h4 class="text-2xl font-bold text-secondary mb-1">……</h4>
                                <p class="text-neutral-400 text-sm">粉丝</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- 页脚 -->
        <footer class="bg-neutral-900 text-white pt-16 pb-8">
            <div class="container mx-auto px-4 sm:px-6 lg:px-8">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
                    <div>
                        <a href="#" class="flex items-center space-x-2 mb-6">
                            <span class="text-2xl text-white font-bold tracking-tight">
                                <i class="fa fa-book-open mr-2"></i>LiAng
                            </span>
                        </a>
                        <p class="text-neutral-400 mb-6">
                            欢迎入群！最好是只入对应小说的群聊（但要保持友好，不聊H，不聊政，不吵架。）
                        </p>
                    </div>

                    <div>
                        <ul class="space-y-3">
                            <li class="flex items-start">
                                <i class="fa fa-qq mt-1 mr-3 text-neutral-400"></i>
                                <span class="text-neutral-400">（Bad Girls）Q群：1075101356</span>
                                <span class="text-neutral-400">（神之复写）Q群：849916881</span>
                            </li>
                            <li class="flex items-start">
                                <i class="fa fa-map-marker mt-1 mr-3 text-neutral-400"></i>
                                <span class="text-neutral-400">暂时居无定所……</span>
                            </li>
                            <li class="flex items-start">
                                <i class="fa fa-envelope-o mt-1 mr-3 text-neutral-400"></i>
                                <span class="text-neutral-400">合作可找：1051966401@qq.com</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="border-t border-neutral-800 pt-8">
                    <div class="flex flex-col md:flex-row justify-between items-center">
                        <p class="text-neutral-500 text-sm mb-4 md:mb-0">
                            版权与备案信息：&copy; 2026 LiAng. 保留所有权利. 未经允许禁止转载盗用| 渝ICP备2026005016号-1
                        </p>
                        <div class="flex space-x-6">
                            <a href="#" @click="goYinSi"
                                class="text-neutral-500 hover:text-white text-sm transition-colors duration-200">隐私政策</a>
                            <a href="#" @click="goShiYong"
                                class="text-neutral-500 hover:text-white text-sm transition-colors duration-200">使用条款</a>
                            <a href="#" @click="goCookie"
                                class="text-neutral-500 hover:text-white text-sm transition-colors duration-200">Cookie
                                政策</a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!-- 返回顶部按钮 -->
        <button id="back-to-top" @click="scrollToTop()"
            class="fixed bottom-8 right-8 bg-primary hover:bg-primary/90 text-white w-12 h-12 rounded-full flex items-center justify-center shadow-lg transition-all duration-300 transform hover:scale-110">
            <i class="fa fa-chevron-up"></i>
        </button>
        <!-- 引入登录弹窗组件 -->
        <LoginModal v-show="isLoginModalVisible" :account="account" @close="handleModalClose"
            @login-success="handleLoginSuccess" />
    </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, nextTick, watch } from 'vue'
import { useRouter } from 'vue-router'
import LoginModal from "@/components/LoginModal.vue";
import GirlKard from '@/components/Decription/GirlKard.vue'
import WordOut from '@/components/Decription/WordOut.vue'
import { useDisableDevTools } from "@/composables/useDisableDevTools";
import { useChapterStore } from "@/store/chapter";
import P1 from '@/assets/Picture/P1.png'
import P2 from '@/assets/Picture/P2.png'
import P3 from '@/assets/Picture/P3.png'
import P4 from '@/assets/Picture/P4.png'
import P5 from '@/assets/Picture/P5.png'
// 在JavaScript里面，不能直接引用路径文件!!
import { useWebSocket } from "@/services/HomeWebSocketService";
// 路由跳转函数
const router = useRouter()

// 章节状态 store
const chapterStore = useChapterStore()

// localStorage 状态ID键名：'hit' → 下次进入初始 P4；'pat' → 下次进入初始 P1
const INTERACT_STATE_KEY = 'interactState'

// 互动插图当前图片（默认 P1，若上次点过"打！"则初始显示 P4）
const currentInteractImg = ref(P1)
if (localStorage.getItem(INTERACT_STATE_KEY) === 'hit') {
    currentInteractImg.value = P4
}

// 点击"摸头"：当前 P5 回 P1；当前 P1 或 P4 统一切到 P5（P4→P5）
const handlePatHead = () => {
    currentInteractImg.value = currentInteractImg.value === P5 ? P1 : P5
    // 修改状态ID：下次进入页面初始显示 P1
    localStorage.setItem('interactState', 'pat')
}

// 点击"打！"：选项框消失 + P1→P2→(1s)→P3→图片右移出屏
const actionHidden = ref(false)
const interactLeaving = ref(false)
let hitTimers = []

const handleHit = () => {
    // 存储状态ID：下次进入页面初始显示 P4
    localStorage.setItem('interactState', 'hit')
    // ① 选项框透明消失（独立留在原地）
    actionHidden.value = true
    // ② 图片切到 P2
    currentInteractImg.value = P2
    // ③ P2 停留 1 秒后切到 P3
    hitTimers.push(setTimeout(() => {
        currentInteractImg.value = P3
    }, 1000))
    // ⑤ P3 淡入完成后，图片组右移出屏（选项框保持消失）
    hitTimers.push(setTimeout(() => {
        interactLeaving.value = true
    }, 3600))
}

// 是否显示"继续阅读"列表
const showContinueList = ref(false)

// 继续阅读列表（复用 readingHistory，显示 书名 标题）
const continueList = computed(() =>
    readingHistory.value.map(item => ({
        ...item,
        display: `${item.novelTitle} ${item.chapterTitle}`
    }))
)

// 保存开发者工具禁用清理函数
let cleanupDevTools = null

const goToWriterCenter = () => {
    router.push('/writer') // 上传页面路由
}
const goToNovelList = (novelId) => {
    router.push({ name: 'NovelChapterList', params: { id: novelId } });
}

// 通过阅读记录直接跳转到阅读页
const goToReaderByHistory = (item) => {
    chapterStore.setCurrentChapter(item.chapterId, item.novelId)
    // 先真实进入列表页（带一次性 jump 标记，让列表页自动续跳到阅读页）
    // 这样列表页会由 Vue Router 正确写入历史栈，浏览器返回时可先回到列表页
    router.push({
        name: 'NovelChapterList',
        params: { id: item.novelId },
        query: { jump: '1' }
    })
}
const goYinSi = () => {
    const route = router.resolve({ path: '/yinSi' }); // 解析路由得到完整路径
    window.open(route.href, '_blank');                // 新标签页打开
}
const goShiYong = () => {
    const route = router.resolve({ path: '/shiYong' }); // 解析路由得到完整路径
    window.open(route.href, '_blank');                // 新标签页打开
}
const goCookie = () => {
    const route = router.resolve({ path: '/cookie' }); // 解析路由得到完整路径
    window.open(route.href, '_blank');                // 新标签页打开
}

const { connected, account, novels, loading, error, error2, fetchNovelsAccount } = useWebSocket();
// 组件挂载后自动请求数据（Axios 版本，无需等待 WebSocket 连接）
const loadData = async () => {
    // Axios 方式：直接调用即可，服务内部已自动请求
    // 无需额外等待逻辑
};

// 状态：控制弹窗显示/隐藏
const isLoginModalVisible = ref(false);

// 点击链接时显示弹窗
const showLoginModal = () => {
    isLoginModalVisible.value = true;
};

// 关闭弹窗
const handleModalClose = () => {
    isLoginModalVisible.value = false;
};

// 登录成功后的处理（跳转至作家中心）
const handleLoginSuccess = () => {
    router.push('/writer'); // 假设作家中心路由为 /writer-center
    handleModalClose(); // 关闭弹窗
};


// 导航栏样式
const navClasses = ref('bg-transparent')

// 移动端菜单
const mobileMenuOpen = ref(false)
const mobileMenuClasses = computed(() =>
    mobileMenuOpen.value ? 'block' : 'hidden'
)

// 返回顶部按钮
const backToTopClasses = ref('opacity-0 invisible')

// 计算阅读历史：从 localStorage 读取所有 read_progress_* 记录，与 novels 匹配
const readingHistory = computed(() => {
    const history = []
    const novelMap = {}
    if (Array.isArray(novels.value)) {
        novels.value.forEach(n => { novelMap[n.id] = n.title })
    }
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key && key.startsWith('read_progress_')) {
            try {
                const progress = JSON.parse(localStorage.getItem(key))
                const novelTitle = novelMap[progress.novelId] || '未知小说'
                const updatedAt = new Date(progress.updatedAt)
                const now = new Date()
                const diffMs = now - updatedAt
                const diffMins = Math.floor(diffMs / 60000)
                const diffHours = Math.floor(diffMs / 3600000)
                const diffDays = Math.floor(diffMs / 86400000)
                let timeAgo = ''
                if (diffMins < 1) timeAgo = '刚刚'
                else if (diffMins < 60) timeAgo = `${diffMins}分钟前`
                else if (diffHours < 24) timeAgo = `${diffHours}小时前`
                else if (diffDays < 30) timeAgo = `${diffDays}天前`
                else timeAgo = updatedAt.toLocaleDateString()
                history.push({
                    novelId: progress.novelId,
                    chapterId: progress.chapterId,
                    chapterTitle: progress.chapterTitle || '',
                    novelTitle,
                    timeAgo,
                    updatedAt: progress.updatedAt
                })
            } catch (e) { /* ignore */ }
        }
    }
    history.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
    return history
})

// 滚动处理
const handleScroll = () => {
    if (window.scrollY > 50) {
        navClasses.value = 'bg-black backdrop-blur-sm shadow-lg'
        backToTopClasses.value = 'opacity-100 visible'
    } else {
        navClasses.value = 'bg-transparent'
        backToTopClasses.value = 'opacity-0 invisible'
    }
}

// 切换移动端菜单
const toggleMobileMenu = () => {
    mobileMenuOpen.value = !mobileMenuOpen.value
}

// 平滑滚动
const smoothScroll = (targetId) => {
    const targetElement = document.querySelector(targetId)

    if (targetElement) {
        smoothScrollTo(targetElement.offsetTop)
    }
}

// 返回顶部
const scrollToTop = () => {
    smoothScrollTo(0)
}

// 页面加载动画
const setupScrollAnimations = () => {
    const animateElements = document.querySelectorAll('.animate-on-scroll')

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-fade-in')
                entry.target.classList.remove('opacity-0')
                observer.unobserve(entry.target)
            }
        })
    }, { threshold: 0.1 })

    animateElements.forEach(element => {
        observer.observe(element)
    })
}

// 生命周期钩子
onMounted(() => {
    // 禁用开发者工具快捷键
    cleanupDevTools = useDisableDevTools()
    // 设置滚动监听
    window.addEventListener('scroll', handleScroll)
    // 初始化滚动动画
    nextTick(() => {
        setupScrollAnimations()
    })
    loadData()
    console.log(novels);

})

onUnmounted(() => {
    // 清理"打！"动画的定时器
    hitTimers.forEach(t => clearTimeout(t))
    // 移除开发者工具禁用监听
    if (cleanupDevTools) cleanupDevTools()
    // 移除滚动监听
    window.removeEventListener('scroll', handleScroll)
})

//平滑滚动函数
function smoothScrollTo(targetY) {
    const startY = window.scrollY;
    const distance = targetY - startY;
    const duration = 500; // 动画持续时间（毫秒）
    let startTime = null;

    function animation(currentTime) {
        if (!startTime) startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        const ease = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
        window.scrollTo(0, startY + distance * ease);
        if (progress < 1) requestAnimationFrame(animation);
    }

    requestAnimationFrame(animation);
}

const loadNovels = () => {
    if (loading.value || !hasMore.value) return;

    loading.value = true;
    error.value = null;

};

const loadMore = () => {
    page.value++;
    loadNovels();
};
</script>

<style scoped lang="scss">
@import "tailwindcss";

.interact-picture {
    position: fixed;
    /* 固定定位：不受上下左右滚动影响 */
    right: 2%;
    /* 贴靠屏幕右侧，留少量边距 */
    top: 18%;
    /* 屏幕右侧中偏上的位置 */
    width: 25vw;
    /* 宽度约为屏幕宽的 1/4，随屏幕宽度缩放 */
    z-index: 9999;
    /* 层级设定最高，不被页面其他元素遮挡 */
}

/* 图片 wrapper：承接图片定位、圆角与阴影，整组右移出屏 */
.interact-img-wrap {
    position: relative;
    width: 100%;
    border-radius: 12px;
    transition: transform 1s ease;
}

/* 图片右移出屏（选项框独立留在原地消失） */
.interact-leaving {
    transform: translateX(110vw);
}

.interact-picture img {
    width: 100%;
    height: auto;
    /* 高度随宽度等比缩放 */
    display: block;
    border-radius: 12px;
    /* 与容器圆角保持一致 */
}

/* 选项框透明消失（独立于图片，留在原位置） */
.action-options {
    transition: opacity 0.3s ease;
}

.action-hidden {
    opacity: 0;
    pointer-events: none;
}

/* 图片切换过渡：旧图绝对定位快速淡出（覆盖预览），新图正常流式快速淡入 */
.img-fade-enter-active {
    transition: opacity 0.3s ease;
}

.img-fade-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    transition: opacity 0.3s ease;
}

.img-fade-enter-from {
    opacity: 0;
    /* 新图从透明浮现 */
}

.img-fade-leave-to {
    opacity: 0;
    /* 旧图快速隐身 */
}

/* 左侧纵向选项框组 */
.action-options {
    position: absolute;
    /* 相对 .interact-picture 定位 */
    right: calc(100% + 1vw);
    /* 紧贴图片左侧 */
    top: 0;
    /* 与图片顶部对齐 */
}

/* 菜单容器（纵向排列选项，transition 需单根子节点） */
.action-menu {
    display: flex;
    flex-direction: column;
    /* 纵向排列选项 */
    gap: 1.2vw;
    /* 选项间距随屏幕宽度缩放 */
}

/* 单个选项框 */
.action-option {
    opacity: 0;
    /* 动画延迟期间先隐藏，避免闪烁 */
    width: 14vw;
    /* 宽度随屏幕宽度缩放 */
    padding: 0.9vw 1vw;
    /* 高度随屏幕宽度缩放 */
    background: rgba(0, 0, 0, 0.75);
    /* 深色半透明底 */
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.25);
    /* 白色描边 */
    border-radius: 0.8vw;
    /* 圆角随屏幕缩放 */
    font-size: 2.2vw;
    /* 字号随屏幕缩放 */
    text-align: center;
    white-space: nowrap;
    cursor: pointer;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
    /* 立体阴影，与图片风格统一 */
    animation: optionSlideIn 0.6s ease-out forwards;
    /* 入场动画：播放一次并保持最终帧 */
    transition: background 0.2s ease, border-color 0.2s ease, filter 0.2s ease;
}

/* 自上而下依次延迟 */
.action-option:nth-child(1) {
    animation-delay: 0s;
}

.action-option:nth-child(2) {
    animation-delay: 0.25s;
}

.action-option:nth-child(3) {
    animation-delay: 0.5s;
}

.action-option:hover {
    background: rgba(30, 58, 138, 0.9);
    /* 悬停变主题蓝 */
    border-color: rgba(255, 255, 255, 0.6);
    /* 边框更亮 */
    filter: brightness(1.15);
    /* 亮度增强 */
}

/* 从右往左滑入 + 透明变正常 */
@keyframes optionSlideIn {
    0% {
        opacity: 0;
        transform: translateX(2vw);
    }
    100% {
        opacity: 1;
        transform: translateX(0);
    }
}

/* 选项组切换：快速淡出 + 快速淡入 */
.opt-fade-enter-active,
.opt-fade-leave-active {
    transition: opacity 0.3s ease;
}

.opt-fade-enter-from,
.opt-fade-leave-to {
    opacity: 0;
}

/* 继续阅读项：沿用 action-option 样式，禁用滑入入场动画避免重影 */
.continue-option {
    animation: none !important;
    opacity: 1 !important;
    width: auto;
    min-width: 14vw;
    max-width: 36vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@layer utilities {
    .content-auto {
        content-visibility: auto;
    }

    .text-shadow {
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .text-shadow-lg {
        text-shadow: 0 4px 8px rgba(0, 0, 0, 0.12), 0 2px 4px rgba(0, 0, 0, 0.08);
    }

    .backdrop-blur-sm {
        backdrop-filter: blur(4px);
    }

    .scrollbar-hide::-webkit-scrollbar {
        display: none;
    }

    .scrollbar-hide {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }

    .transition-transform-opacity {
        transition-property: transform, opacity;
    }
}

#novels {
    background: radial-gradient(
        ellipse at 50% 40%,
        #3e454e 0%,
        #383e47 60%,
        #292929 100%
    );
}

#poems {
    background: radial-gradient(
        ellipse at 50% 40%,
        #3e454e 0%,
        #383e47 60%,
        #292929 100%
    );
}

#back-to-top {
    width: 50px;
    height: 50px;
    background-color: #42b983;

}
</style>